export default __webpack_public_path__ + "121b45c017738652e491dcb30a6f5ce8.ttf";